"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _pragma = require("../../../pragma");

var _react = _interopRequireDefault(require("react"));

var _ = require("../..");

var css = _interopRequireWildcard(require("./QuarterlyReportCard.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// components
// styles
const QuarterlyReportCard = ({
  width = '428px',
  srcLogo = '',
  title,
  subtitle,
  statistics,
  onClick
}) => (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  alignItems: "flex-start",
  css: css.wrapper,
  onClick: onClick,
  cssProps: {
    width
  }
}, (0, _pragma.createFelaElement)(_.View, {
  margin: [0, 0, 24]
}, (0, _pragma.createFelaElement)("img", {
  css: css.logo,
  loading: "lazy",
  src: srcLogo,
  alt: "logoImage"
})), (0, _pragma.createFelaElement)(_.View, {
  flexDirection: "column",
  margin: [0, 0, 24],
  gap: 8
}, (0, _pragma.createFelaElement)(_.Text, {
  variant: "bodyBold",
  color: "text.1"
}, title), (0, _pragma.createFelaElement)(_.Text, {
  variant: "meta"
}, subtitle)), (0, _pragma.createFelaElement)(_.ViewsStatistics, statistics));

QuarterlyReportCard.displayName = 'QuarterlyReportCard';
var _default = QuarterlyReportCard;
exports.default = _default;
//# sourceMappingURL=QuarterlyReportCard.js.map